import {SessionBeginRequest, SessionBeginResponse} from 'app';
import {ApiClient, retryable} from 'features';

export const beginSession = async (
  request: SessionBeginRequest
): Promise<SessionBeginResponse> => {
  const sessionClient = ApiClient();
  return retryable(() => sessionClient.beginSession('', request));
};
